'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$ConfigureGroupSigning(code, blocked) {
  this.LH = null;
  this.LG = false;
  this.LH = code;
  this.LG = blocked;
}
export { $c_Lpresto_types$proto$ConfigureGroupSigning as $c_Lpresto_types$proto$ConfigureGroupSigning };
$p = $c_Lpresto_types$proto$ConfigureGroupSigning.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$ConfigureGroupSigning;
/** @constructor */
function $h_Lpresto_types$proto$ConfigureGroupSigning() {
}
export { $h_Lpresto_types$proto$ConfigureGroupSigning as $h_Lpresto_types$proto$ConfigureGroupSigning };
$h_Lpresto_types$proto$ConfigureGroupSigning.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("ConfigureGroupSigning"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.LH));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.LG ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$ConfigureGroupSigning) && ((this.LG === x$0.LG) && (this.LH === x$0.LH))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ConfigureGroupSigning";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.LH;
  }
  if ((n === 1)) {
    return this.LG;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$ConfigureGroupSigning(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kH)));
}
export { $isArrayOf_Lpresto_types$proto$ConfigureGroupSigning as $isArrayOf_Lpresto_types$proto$ConfigureGroupSigning };
var $d_Lpresto_types$proto$ConfigureGroupSigning = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$ConfigureGroupSigning, "presto.types$proto$ConfigureGroupSigning", ({
  kH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$ConfigureGroupSigning as $d_Lpresto_types$proto$ConfigureGroupSigning };
//# sourceMappingURL=presto.types$proto$-Configure-Group-Signing.js.map
